/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-else-return */
/* eslint-disable no-unreachable */
/* eslint-disable prefer-const */
/* eslint-disable radix */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable array-func/prefer-array-from */
/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-magic-numbers */
/* eslint-disable global-require */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable eqeqeq */
/* eslint-disable no-const-assign */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable max-lines */
/* eslint-disable fp/no-let */
/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
/* eslint-disable @scandipwa/scandipwa-guidelines/no-jsx-variables */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import { faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import {
    faPlayCircle,
    faStar
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    get, isEmpty, map, upperCase
} from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, lazy, Suspense } from 'react';
import LazyLoad from 'react-lazy-load';
// import OwlCarousel from 'react-owl-carousel';
import { Link as RouterLink } from 'react-router-dom';
import Slider from 'react-slick';
import Cookies from 'universal-cookie';

import AccordionWrapper from 'Component/AccordionWrapper';
import CloseIcon from 'Component/CloseIcon';
import CmsBanner from 'Component/Cms/CmsBanner';
import CmsProductSlider from 'Component/CmsProductSlider/CmsProductSlider';
import SalesLargeCountdown from 'Component/Countdown/SalesLargeCountdown';
import Field from 'Component/Field';
import Form from 'Component/Form';
import { WithGoogleRecaptcha } from 'Component/GoogleRecaptchaV3/GoogleRecaptchaV3.component';
import Link from 'Component/Link';
import Loader from 'Component/Loader';
import MyAccountMyOrdersHome from 'Component/MyAccountMyOrdersHome';
import RackFamilyBlock from 'Component/RackFamilyBlock';
import VehicleFinder from 'Component/VehicleFinder';
import VideoPopup from 'Component/VideoPopup';
import VideoThumbnail from 'Component/VideoThumbnail';
import WhyUsBlock from 'Component/WhyUsBlock';
// import YotpoLoyaltyTermsComponent from 'Component/YotpoLoyalty/YotpoLoyaltyTerms.component';
import Html from 'SourceComponent/Html';
import Image from 'SourceComponent/Image';
import TextPlaceholder from 'SourceComponent/TextPlaceholder';
import { isSignedIn } from 'Util/Auth';
import {
    isAusStore, isEurStore, isIntStore,
    isRsaStore, isUsaStore
} from 'Util/FrontRunner/Store';
import { getBlackFridayPromo, getSalesPromotion, getXmasPromo } from 'Util/FrontRunner/Store/Promotions';
import { isB2BUser, md5, scrollToTop } from 'Util/Helper';
import isMobile from 'Util/Mobile';
import { removeBaseUrl } from 'Util/Url';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './HomePage.style.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// import MyAccountOrderPopup from '../../component/MyAccountOrderPopup';
export const LazyBrandVideo = lazy(() => import('../../component/BrandVideo/BrandVideo'));

// import './CmsPage.style';
export const cookies = new Cookies();

export const options = {
    loop: true,
    infinite: true,
    arrows: true,
    dots: true,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    lazyLoad: true,
    margin: 1,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }
        }
    ]
    // responsive: {
    //     0: {
    //         items: 1
    //     },
    //     650: {
    //         items: 2
    //     },
    //     1000: {
    //         items: 3
    //     },
    //     1500: {
    //         items: 4
    //     }
    // }
};
export const optionsPost = {
    loop: true,
    nav: true,
    dots: false,
    autoplay: false,
    lazyLoad: false,
    centerPadding: '60px',
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    // responsive: {
    //     0: {
    //         items: 1
    //     },
    //     650: {
    //         items: 2
    //     },
    //     1000: {
    //         items: 3
    //     }
    // }
};

/** @namespace Pwa/Route/HomePage/Component/HomePageComponent */
export class HomePageComponent extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        isBreadcrumbsActive: PropTypes.bool,
        showPopup: PropTypes.func,
        companyProfile: PropTypes
        // page: BlockListType.isRequired
    };

    static defaultProps = {
        isBreadcrumbsActive: true
    };

    state = {
        email: '',
        isRunningLookup: false,
        isCountdownComplete: false
    };

    componentDidMount() {
        if (isMobile.any()) {
            const updateWidgetPosition = () => {
                // Set zendesk widget position on mobile
                const launcher = document.getElementById('launcher');
                if (launcher) {
                    launcher.style.bottom = '3px';
                    launcher.style.right = '0px';
                }
            };

            // Try to update immediately
            updateWidgetPosition();

            // Also set a timeout to try again after a short delay
            setTimeout(updateWidgetPosition, 2000);
        }

        this.updatedToGaDataHomePage();
    }

    updatedToGaDataHomePage() {
        let emailId = '';
        if (isSignedIn()) {
            emailId = localStorage.getItem('email_id', '');
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'homePage',
            ecommerce: {
                pageType: 'homePage',
                customer: {
                    email: emailId
                }
            }
        });
    }

    renderHeading() {
        const { page: { content_heading } } = this.props;

        if (!content_heading) {
            return null;
        }

        return (
            <h1 block="CmsPage" elem="Heading">
                <TextPlaceholder content={ content_heading } />
            </h1>
        );
    }

    renderContent() {
        const { isLoading, page: { content } } = this.props;

        if (!isLoading && !content) {
            return null;
        }

        if (!content) {
            return (
                <>
                    <div block="CmsPage" elem="SectionPlaceholder" />
                    <div block="CmsPage" elem="SectionPlaceholder" />
                    <div block="CmsPage" elem="SectionPlaceholder" />
                </>
            );
        }

        return <Html content={ content } />;
    }

    addBase = (src) => {
        const baseUrl = window.location.origin;

        let srcString = src;
        if (srcString.charAt(srcString.length - 1) == '/') {
            srcString = srcString.substring(0, srcString.length - 1);
        }

        return `${baseUrl}${srcString}`;
    };

    getTextShadowClass = (color) => {
        switch (upperCase(color)) {
        case 'FFF':
        case 'FFFFFF':
            return 'text-shadow';
        default:
            return '';
        }
    };

    /**
     * Renders a video thumbnail which opens popup player on click/tap
     * @param media
     * @param index
     * @returns {*}
     * @private
     */
    renderVideo(media, index) {
        return (
          <VideoThumbnail
            key={ index }
            media={ media }
          />
        );
    }

    getSliderContent = (gallery) => {
        const {
            button_text,
            button_url,
            content_bottom,
            content_bottom_color,
            content_bottom_size = '32',
            content_bottom_font,
            content_position,
            content_position_vertical,
            content_top,
            content_top_color,
            content_top_size = '18',
            content_top_font,
            banner_type = '',
            date_from,
            date_to
        } = gallery;

        const mobile_image = this.addBase(gallery.image_mobile);

        const topTextShadowClass = this.getTextShadowClass(content_top_color);
        const bottomTextShadowClass = this.getTextShadowClass(content_bottom_color);

        let frSliderContentTop = 'fr_slider_content_top';
        let frSliderContentBottom = 'fr_slider_content_bottom';
        if (parseInt(content_bottom_size) < parseInt(content_top_size)) {
            frSliderContentTop = 'fr_slider_content_bottom';
            frSliderContentBottom = 'fr_slider_content_top';
        }

        const fontMapping = {
            regular_bold: '"regular-bold", sans-serif',
            intro: '"Intro", sans-serif'
        };
        const contentTopFont = fontMapping[content_top_font] || '"regular-bold", sans-serif';
        const contentBottomFont = fontMapping[content_bottom_font] || '"Intro", sans-serif';

        return (
          <div
            className={ `content ${content_position} ${content_position_vertical}` }
            style={ { verticalAlign: content_position_vertical, textAlign: content_position } }
          >
            <div
              className={ `${frSliderContentTop} ${topTextShadowClass}` }
              style={ { color: content_top_color, fontSize: `${content_top_size}px`, fontFamily: contentTopFont } }
            >
              <Html content={ content_top } />
            </div>
            <div
              className={ `${frSliderContentBottom} ${bottomTextShadowClass}` }
              style={ { color: content_bottom_color, fontSize: `${content_bottom_size}px`, fontFamily: contentBottomFont } }
            >
              <Html content={ content_bottom } />
            </div>
            <div className="link">
              { this.renderButton(banner_type, button_url, button_text, content_top, mobile_image) }
            </div>
          </div>
        );
    };

    showVideosPopup = (button_url) => {
        const { isEnabledVideosPopup = false } = this.state;
        const cloudflareVideoUrl = 'https://customer-v69dny9pou827000.cloudflarestream.com/961bde69c42b665163908c05de96018d/iframe?autoplay=true&poster=https%3A%2F%2Fcustomer-v69dny9pou827000.cloudflarestream.com%2F961bde69c42b665163908c05de96018d%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600';
        this.setState({ isEnabledVideosPopup: !isEnabledVideosPopup, currentVideoLink: cloudflareVideoUrl });
    };

    renderVideosPopup = () => {
        const { isEnabledVideosPopup = false, currentVideoLink = '' } = this.state;

        if (!isEnabledVideosPopup || isEmpty(currentVideoLink)) {
            return null;
        }

        return (
          <div className="VideosPopup" onClick={ this.showVideosPopup }>
            <div className="VideosPopupWrapp">
            { currentVideoLink && (
              <div onClick={ this.showVideosPopup } className="close">×</div>
            ) }
            <div style={{ position: 'relative', paddingTop: '56.25%' }}>
              <iframe
                src={ currentVideoLink }
                loading="lazy"
                style={{
                    border: 'none',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%'
                }}
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
                title="Front Runner Keep Searching"
              />
            </div>
            </div>
          </div>
        );
    };

    renderMyOrderDetails = () => {
        const { companyCustomerData = {} } = this.props;
        const { customer_info, customer_account = {}, billing_address = {} } = companyCustomerData || {};
        let firstname = '';
        let dealer_code = '';
        let email = '';
        let account_email = '';
        let company_name = '';
        let city = '';
        let postcode = '';
        let street = '';
        let available_balance = 0;
        let credit_limit = 0;

        if (customer_info) {
            // Override default values if customer_info is available.
            ({
                firstname = '', dealer_code = '', email = '', account_email = '', company_name = ''
            } = customer_info);
        }
        if (customer_account) {
            // Override default values if customer_account is available.
            ({ available_balance = 0, credit_limit = 0 } = customer_account);
        }
        if (billing_address) {
            // Override default values if billing_address is available.
            ({ city = '', postcode = '', street = '' } = billing_address);
        }
        // const {
        //     city, postcode, street
        // } = billing_address;

        return (
          <div className="MyOrderDetails mg_30">
            <div className="MyOrderTop">
            <h3>
              { __('Welcome back, %s', firstname) }
            </h3>
            <Link
              to="/my-account/"
              className="Dash btn-2"
            >
              { __('Dashboard') }
            </Link>
            <Link
              to="/quickorder/"
              className="QuickOrd btn-2"
            >
              { __('Quick Order') }
            </Link>
            </div>
          <div className="MyCompanyOder">
            <div className="MyCompany">
                <h3>
                  { __('My Company') }
                </h3>
                <div className="MyCompanyBox">
                    <div className="MyCompanyBoxInner">
                      <div className="title">
                        { company_name }
                      </div>
                      <div className="text">
                        <span>
                          { __('Dealer Code:') }
                        </span>
                        { dealer_code }
                      </div>
                      <div className="text">
                        <span>
                          { `${__('Email')}:` }
                        </span>
                        { email }
                      </div>
                      <div className="text">
                        <span>
                          { `${__('Account Email')}:` }
                        </span>
                        { account_email }
                      </div>
                    </div>
                    <div className="MyCompanyBoxInner">
                      <div className="title">
                        { __('Account') }
                      </div>
                      <div className="text">
                        <span>
                          { __('Credit limit:') }
                        </span>
                        { credit_limit }
                      </div>
                      <div className="text">
                        <span>
                          { `${__('Credit Balance')}:` }
                        </span>
                        { available_balance }
                      </div>
                    </div>
                    <div className="MyCompanyBoxInner">
                      <div className="title">
                        { __('Billing Address') }
                      </div>
                      <div className="text">
                       <div className="text">{ street }</div>
                       <div className="text">{ city }</div>
                       <div className="text">{ postcode }</div>
                      </div>
                    </div>
                    <div>
                      <Link
                        to="/my-account/company_users"
                        className="QuickOrd btn-2"
                      >
                        { __('Manage Users') }
                      </Link>
                      <Link
                        to="/my-account/address-book"
                        className="QuickOrd btn-2"
                      >
                        { __('Manage Addresses') }
                      </Link>
                    </div>
                </div>
            </div>
            <div className="RecentOrders">
                <h3>
                  { __('Recent Orders') }
                </h3>
                <div className="RecentOrdersBox">
                  <MyAccountMyOrdersHome />
                  <div className="RecentOrdersBoxBtn">
                      <Link
                        to="/my-account/my-orders"
                        className="QuickOrd btn-2"
                      >
                        { __('Show All Orders') }
                      </Link>
                      <Link
                        to="/my-account/company-statements"
                        className="QuickOrd btn-2"
                      >
                        { __('Statements') }
                      </Link>
                  </div>
                </div>
            </div>
          </div>
          </div>
        );
    };

    renderStaticBlock = () => {
        // TODO: Chris / Build into Magento 2 config section
        let newsletterLink = null;
        let dealerAssetsLink = null;

        if (isUsaStore()) {
            newsletterLink = 'https://email.frontrunneroutfitters.com/t/54ZY-VUS6-E3000D423B8B6643C23VMB7DA436D0D82E8F9/cr.aspx';
            dealerAssetsLink = 'https://frontrunner.chorus-mk.thirdlight.com/link/dew0442wwlou-1aejb2';
        }
        if (isRsaStore()) {
            newsletterLink = 'https://email.frontrunneroutfitters.com/t/54ZY-S28A-E3000D423B8B6643C23VMB7DA436D0D82E8F9/cr.aspx';
            dealerAssetsLink = 'https://email.frontrunneroutfitters.com/t/54ZY-S28A-C23VM-LODHS-1/c.aspx';
        }
        if (isEurStore(false)) {
            newsletterLink = 'https://email.frontrunneroutfitters.com/t/54ZY-SGT9-E3000D423B8B6643C23VMB7DA436D0D82E8F9/cr.aspx';
            if (window.storeConfig.code === 'de_de') {
                newsletterLink = 'https://email.frontrunneroutfitters.com/t/54ZY-SQWB-E3000D423B8B6643C23VMB7DA436D0D82E8F9/cr.aspx';
            }
            if (window.storeConfig.code === 'fr_be') {
                newsletterLink = 'https://email.frontrunneroutfitters.com/t/54ZY-SQY3-E3000D423B8B6643C23VMB7DA436D0D82E8F9/cr.aspx';
            }
            dealerAssetsLink = 'https://frontrunner.thirdlight.com/link/dealerassetseu';
        }
        if (isAusStore()) {
            newsletterLink = 'https://email.frontrunneroutfitters.com/t/54ZY-SFGG-E3000D423B8B6643C23VMB7DA436D0D82E8F9/cr.aspx';
            dealerAssetsLink = 'https://frontrunner.thirdlight.com/link/AUSDealer';
        }

        return (
        <div className="StaticBlocks mg_30">
            <div className="StaticBlock">
                <h3>
                  { __('Sales & Marketing Tools') }
                </h3>
                <div className="StaticBlockBtn">
                  <Link
                    to={ dealerAssetsLink }
                    className="QuickOrd btn-2"
                    target="_blank"
                  >
                  { __('Dealer Assets') }
                  </Link>
                  <Link
                    to="https://www.youtube.com/c/Frontrunneroutfitters/featured"
                    className="QuickOrd btn-2"
                    target="_blank"
                  >
                    { __('Videos') }
                  </Link>
                </div>
            </div>

            <div className="StaticBlock">
                <h3>
                  { __('Brochures / Sell Sheets') }
                </h3>
                <div className="StaticBlockBtn">
                  <Link
                    to="/download-brochures"
                    className="QuickOrd btn-2"
                    target="_blank"
                  >
                    { __('Show all') }
                  </Link>
                </div>
            </div>

            {/* <div className="StaticBlock">
                <h3>
                  { __('Latest Newsletter') }
                </h3>
                <div className="StaticBlockBtn">
                  <Link
                    to={ newsletterLink }
                    className="QuickOrd btn-2"
                    target="_blank"
                  >
                    { __('View Online') }
                  </Link>
                </div>
            </div> */}
        </div>
        );
    };

    // Render Frequently Purchased Product Slider Block
    renderFrequentlyPurchasedSlider = (skus) => {
        const slideItem = this.renderProducts(skus);
        return (
        <div className="lp-product-slider mg_30">
          <h3>
            { __('This Month\'s Featured Products') }
          </h3>
          { slideItem }
        </div>
        );
    };

    // Render Featured Product Slider Block
    renderFeaturedProSlider = (skus) => {
        const slideItem = this.renderProducts(skus);
        return (
          <div className="lp-product-slider mg_30">
            <h3>
              { __('Frequently Purchased Items') }
            </h3>
            { slideItem }
          </div>
        );
    };

    renderVehicleFinderSection = () => {
        const { vehicleList = [] } = this.props;
        let cls = '';
        if (vehicleList.length == 1) {
            cls = 'vehicleHide';
        }

        return (
          <div className={`VehicleFinderSection mg_30 ${cls}`}>
            <div className="VehicleFinderLeft">
                <div className="VehicleFinderImg"> </div>
                <div className="VehicleFinderWrap">
                  <h3>{ __('Outfit your vehicle') }</h3>
                  <VehicleFinder />
                </div>
            </div>
          </div>
        );
    };

    // Render Vehicle Slider
    renderGearForYourSlider = () => {
        const { vehicleSpecificSkus = [], selectedVehicle, vehicleList = [] } = this.props;
        // const staticSkus = 'SBOX031,JCHO013,JCHO014,RRAC150,RRAC129,RRAC147,RRAC103,KRTR004T,WTAN063,RRAC173,WTAN050,RRAC170';
        // let skus = staticSkus;
        // if (vehicleSpecificSkus && vehicleSpecificSkus !== '' && vehicleSpecificSkus.length > 0) {
        //     skus = vehicleSpecificSkus;
        // }
        const slideItem = this.renderProducts(vehicleSpecificSkus);
        if (vehicleList.length > 1 || vehicleList.length < 1) {
            return null;
        }

        return (
          <div className="lp-product-slider mg_30">
            <h3>
              { __(selectedVehicle) }
            </h3>
            {slideItem}
          </div>
        );
    };

    // Render Top Selling Products
    renderTopSellingProductsSlider = (skus) => {
        const slideItem = this.renderProducts(skus);
        return (
          <div className="lp-product-slider mg_30">
            <h3>
              { __('Top Selling Products') }
            </h3>
            { slideItem }
          </div>
        );
    };

    // Render Products
    renderProducts = (skus) => (
        <CmsProductSlider
          productsskuarray={ skus }
          data={ skus }
          isRelated={ false }
          // key={ `lp-products-${item.id}` }
        />
    );

    getPage = () => {
        scrollToTop();
    };

    renderLatestGearzetteArticles = (item) => {
        const recentPostItemData = item.map((postItem, index) => {
            const {
                id = '40',
                title = '',
                featured_image_mobile = '',
                post_links = []
            } = postItem;

            const { post_link = '' } = post_links[0];

            let linkTo = post_link.replace(window.storeConfig.baseName, '/');
            linkTo = `/gearzette/${linkTo}`;
            // const imgUrl = (isMobile.any()) ? featured_image_mobile : featured_image_desktop;
            const imgPrUrl = 'https://www.frontrunneroutfitters.com';
            // if (index > 2) {
            //     return null;
            // }

            return (
              <div>
                  { (title) && (
                      <Link
                        block="PostItem"
                        elem="Link"
                        to={ linkTo }
                        key={ id }
                      >
                           <div className="PostItem" key={ id }>
                              { (featured_image_mobile) && (
                                  <div className="fr-post-list-featured-image">
                                      <img
                                        src={ `${imgPrUrl}/media/${featured_image_mobile}?width=441&height=300&fit=cover` }
                                        loading="lazy"
                                        alt="post-img"
                                        width="441"
                                        height="300"
                                      />
                                  </div>
                              ) }
                              <div className="fr-post-list-content">
                                  <h4 className="lp-recent-post-item-header ">
                                      { title }
                                  </h4>
                              </div>
                              <Link
                                className="btn btn-primary"
                                to={ linkTo }
                              >
                                { __('Read more') }
                              </Link>
                           </div>
                      </Link>
                  ) }
              </div>
            );
        });

        return (
          <LazyLoad>
              <div className="latestGearzetteArticlesBlock mg_30">
                <h3>
                  { __('Latest Gearzette Blog Articles') }
                  <Link
                    to="/gearzette"
                    className="btn-2"
                    onClick={ this.getPage }
                  >
                    { __('Show all') }
                  </Link>
                </h3>
                <div className="latestGearzetteArticles">
                  {!isEmpty(recentPostItemData) && (
                      <Slider
                        // className="owl-theme"
                        { ...optionsPost }
                      >
                        { recentPostItemData }
                      </Slider>
                  )}
                </div>
              </div>
          </LazyLoad>
        );
    };

    renderB2bContent = () => {
        const { customer = {}, companyCustomerData = {} } = this.props;
        const productSliderBlock = get(this.props, 'productSlider', null);
        const content = get(this.props, 'content', {});
        const { is_b2b } = customer;

        if (isB2BUser(is_b2b)) {
            const { featured_product_skus = '', frequently_product_skus = '' } = companyCustomerData;
            return (
                <div className="homepageB2B">
                  {/* { !isEmpty(productSliderBlock) && this.renderHeroBannerBlock(productSliderBlock) } */}
                  <div className="container">
                    { this.renderMyOrderDetails() }
                    { this.renderPickUpWhereYouLeftOff() }
                    { featured_product_skus && this.renderFrequentlyPurchasedSlider(featured_product_skus) }
                    { this.renderStaticBlock() }
                    {/* { frequently_product_skus && this.renderFeaturedProSlider(frequently_product_skus) } */}
                  </div>
                  { !isEmpty(productSliderBlock) && this.renderProductSliderBlock(productSliderBlock) }
                  {/* { (!isUsaStore() && !isRsaStore() && !isAusStore() && !isIntStore()) && !isEmpty(productSliderBlock) && this.renderProductSliderBlock(productSliderBlock) } */}
                  {/* { (isUsaStore() || isRsaStore() || !isAusStore() || isIntStore()) && this.renderSecStaticSlider() } */}
                  { !isEmpty(content) && this.renderHomepageContent(content) }
                </div>
            );
        }

        return null;
    };

    renderExploreOurProductCategories = (category) => {
        const catData = category.map((data) => (
          <Link
            to={data.url}
            className="ProCatName"
          >
            {data.name}
          </Link>
        ));

        return (
          <div className="lp-product-slider mg_30">
            <h3>
              { __('Explore Our Product Categories') }
            </h3>
            <div className="ExploreOurProductCategories">
              {catData}
            </div>
          </div>
        );
    };

    renderPickUpWhereYouLeftOff = () => {
        const skusList = localStorage.getItem('skusList', '');
        const data = skusList?.split(',')?.filter((item, pos, self) => self.indexOf(item) == pos);
        const result = data?.slice(0, 10);
        const skusLists = result?.join(',');
        const slideItem = this.renderProducts(skusLists);
        if (!skusList) {
            return null;
        }

        return (
          <div id="pickUpWhereLeftOff">
            <div className="lp-product-slider mg_30">
              <h2>
                { __('Pick up where you left off') }
              </h2>
              <div className="ExploreOurProductCategories">
                {slideItem}
              </div>
            </div>
          </div>
        );
    };

    renderB2cContent = () => {
        const {
            customer = {}, recentsPost = {}, companyCustomerData, menu, bestSellerProductsData
        } = this.props;
        const { header_content = [{}] } = menu;
        const [{ shop: [{ category }] }] = header_content;
        const productSliderBlock = get(this.props, 'productSlider', null);
        const { is_b2b } = customer;
        const { sku } = bestSellerProductsData;
        const { data = [] } = recentsPost;
        const content = get(this.props, 'content', {});

        if (!isB2BUser(is_b2b)) {
            return (
              <div className="homepageB2C">
                  { this.renderPromoCountdown() }
                  {/* <div className="mg_30"> */}
                  {/* { isEurStore() && !isEmpty(productSliderBlock) && this.renderProductSliderBlock(productSliderBlock) } */}
                  { this.renderHeroBannerBlock() }
                  { this.renderSecStaticSlider() }
                  <div className="container">
                    { this.renderPickUpWhereYouLeftOff() }
                  </div>
                  { this.renderStaticCategories() }

                  {/* { isEmpty(productSliderBlock) && (
                      <>
                      <div className="homepageB2C">
                        <div className="fr_banner_hero">
                          <h1 className="fr_banner_title">
                            <TextPlaceholder content="" />
                            <Link
                              block="Homepage"
                              elem="Link btn btn-primary"
                              to="/gift-card.html"
                            >
                              Go
                            </Link>
                          </h1>
                        </div>
                        <div className="fr_banner_carousel_initial">
                          <OwlCarousel
                            className="owl-theme"
                            { ...options }
                          >
                            <div className="item">
                              <div className="fr_banner_item item" />
                              <div className="fr_banner_item item" />
                              <div className="fr_banner_item item" />
                              <div className="fr_banner_item item" />
                              <div className="fr_banner_item item" />
                            </div>
                          </OwlCarousel>
                        </div>
                      </div>
                      </>
                  ) } */}

                  {/* <div className="container">
                    { this.renderVehicleFinderSection() }
                    { isSignedIn() && this.renderGearForYourSlider() }
                  </div> */}

                  {/* </div> */}
                  {/* <div className="container">
                  { this.renderTopSellingProductsSlider(sku) }
                  { this.renderExploreOurProductCategories(category) }
                  { this.renderPickUpWhereYouLeftOff() }
                  { this.renderLatestGearzetteArticles(data) }
                  </div> */}
                  { this.renderYotpoLoyaltyBanner() }
                  {/* { this.renderCmsBanner() } */}
                  { this.renderVehicleTestFitmentsBlocks() }
                  { this.renderStaticBrandVideo() }
                  <WhyUsBlock />
                  { !isEmpty(content) && this.renderHomepageContent(content) }
              </div>
            );
        }

        return null;
    };

    renderButton = (banner_type, button_url, button_text, content_top, mobile_image) => {
        if (!isEmpty(banner_type)) {
            if (banner_type === 'video_popup') {
                const video_content = { video_url: button_url, video_title: content_top };
                const thumbnail = { url: mobile_image };

                const media = { video_content, thumbnail };
                const payload = { media };
                const index = '1';

                return (
                  <Link
                    block="Homepage"
                    elem="Link Video btn btn-primary"
                    to="/"
                    onClick={ () => this.showVideosPopup(button_url) }
                  >
                      <FontAwesomeIcon icon={ faPlayCircle } />
                      { button_text }
                  </Link>
                );
            }

            if (banner_type === 'newsletter_link') {
                return (
                  <Link
                    block="Homepage"
                    elem="Link btn btn-primary"
                    to={ button_url }
                    onClick={ (e) => {
                        e.preventDefault();
                        document.querySelector('.social_block_usa').scrollIntoView({ behavior: 'smooth' });
                    } }
                  >
                    Subscribe
                  </Link>
                );
            }

            if (banner_type === 'external_link') {
                return (
                  <Link
                    block="Homepage"
                    elem="Link btn btn-primary"
                    to={ button_url }
                    target="_blank"
                  >
                    { button_text }
                  </Link>
                );
            }
        }

        return (
          <Link
            block="Homepage"
            elem="Link btn btn-primary"
            to={`/${button_url}`}
          >
              { button_text }
          </Link>
        );
    };

    handleVideoPlayer = (payload) => {
        const { showPopup } = this.props;
        const { media } = payload;

        showPopup({
            media,
            title: 'Front Runner Dometic Video'
        });
    };

    /**
     * @deprecated
     */
    getProductSliderContent = (gallery) => {
        const {
            title,
            subtitle,
            price,
            url_text,
            url
        } = gallery;

        return (
        <div className="fr_banner_item item">
          <h2 className="title">
            { ' ' }
            <Html content={ title } />
            { ' ' }
          </h2>
          <div className="fr_banner_content_bottom">
              <div className="subtitle">
                { ' ' }
                <Html content={ subtitle } />
                { ' ' }
              </div>
              <div className="price">
                { ' ' }
                { price }
              </div>
              <div className="link">
                <Link
                  block="Homepage"
                  elem="Link btn btn-primary"
                  to={ removeBaseUrl(url) }
                  onClick={ () => scrollToTop() }
                >
                  { url_text }
                </Link>
              </div>
          </div>
        </div>
        );
    };

    /**
     * @deprecated
     */
    renderSliderImages = (gallery, type = 'home') => (map(gallery, (g, key) => {
        const mobile_image = this.addBase(g.image_mobile);
        const desktop_image = this.addBase(g.image);
        const { content_top, title } = g;
        const contentDiv = (type === 'home') ? this.getSliderContent(g) : this.getProductSliderContent(g);
        let loadingType = 'lazy';
        let fetchpriority = 'low';
        if (key === 0) {
            loadingType = 'eager';
            fetchpriority = 'high';
        }

        return (
          <div className="item" key={ key }>
            { contentDiv }
            <picture>
              <source media="(max-width: 800px)" srcSet={ mobile_image } />
              <source media="(min-width: 801px)" srcSet={ desktop_image } />
              <img src={ desktop_image } alt={ content_top || title || 'Outfit Your Vehicle | Front Runner Dometic' } loading={ loadingType } fetchpriority={ fetchpriority } width="640" height="440" />
            </picture>
          </div>
        );
    }));

    /**
     * @deprecated
     */
    renderOwlSlider = (gallery) => {
        // Set vfits image per region
        let vfitsImg = null;
        let vfitsImgMobile = null;
        if (isUsaStore()) {
            vfitsImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/usa.jpg';
            vfitsImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/usa_mobile.jpg';
        }
        if (isEurStore()) {
            vfitsImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/eur.jpg';
            vfitsImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/eur_mobile.jpg';
        }
        if (isAusStore()) {
            vfitsImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/aus.jpg';
            vfitsImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/aus_mobile.jpg';
        }
        if (isRsaStore() || isIntStore()) {
            vfitsImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/rsa.jpg';
            vfitsImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/vfits/rsa_mobile.jpg';
        }

        let adventureText = __('Get ready for, adventure');
        adventureText = adventureText.split(',');

        // Lower auto play timeout for USA promo
        const autoplayTimeout = 6000;
        // if (isUsaStore()) {
        //     autoplayTimeout = 4500;
        // }
        const { customer = {} } = this.props;
        const { is_b2b } = customer;
        let is_b2c = false;
        if (isSignedIn() && !isB2BUser(is_b2b)) {
            is_b2c = true;
        }

        return (
            <Slider
              className="owl-theme"
              loop
              margin={ 0 }
              nav
              items={ 1 }
              dots
              autoplay
              autoplayTimeout={ autoplayTimeout }
              autoplayHoverPause
              lazyLoad={ false }
            >
                {/* <div className="item" key="vfits">
                  <div className="content left top xs-hidden">
                    { !isMobile.any() && !is_b2c && (
                        <>
                        <div className="fr_slider_content_bottom text-shadow" style={{ color: '#fff', fontSize: '34px' }}>
                          {__('Outfit your vehicle')}
                        </div>
                        <br />
                      <VehicleFinder />
                        </>
                    )}
                  </div>
                    <div className="content left top lg-hidden" style={ { verticalAlign: 'top', textAlign: 'left', textTransform: 'uppercase' } }>
                        <div className="fr_slider_content_top text-shadow" style={ { color: '#fff' } }>
                            { adventureText[0].trim() }
                            { ' ' }
                            <br />
                            <span className="fr_slider_content_bottom text-shadow" style={ { color: '#fff' } }>
                                { adventureText[1].trim() }
                            </span>
                        </div>
                        <Link
                          to="/outfit-your-vehicle"
                          block="Homepage"
                          elem="Link"
                          className="btn btn-primary"
                        >
                            { __('Outfit your vehicle') }
                        </Link>
                    </div>
                    <picture>
                        <source media="(max-width: 800px)" srcSet={ vfitsImgMobile } />
                        <source media="(min-width: 801px)" srcSet={ vfitsImg } />
                        <img src={ vfitsImg } alt="Outfit Your Vehicle | Front Runner Dometic" title="Outfit Your Vehicle" width="500" height="344" />
                    </picture>
                </div> */}
                { this.renderSliderImages(gallery) }
            </Slider>
        );
    };

    renderProductSlides = (productSlides) => (
        <Slider
          className="owl-theme"
          { ...options }
        >
          { this.renderSliderImages(productSlides, 'productSlides') }
        </Slider>
    );

    renderHeroBannerBlock = () => {
        // let linkLabel = get(blockData, 'banner[0].link_label', null);
        // let linkUrl = removeBaseUrl(get(blockData, 'banner[0].link_url', null));
        // let bannerTitle = get(blockData, 'banner[0].title', null);

        return null;

        let linkLabel = __('Shop Now');
        let linkUrl = null;
        let bannerTitle = null;
        let bannerSubtext = null;
        let termsText = null;
        const { customer = {} } = this.props;
        const { is_b2b } = customer;
        // Check if B2B customer (Use local storage check)
        const isB2B = isB2BUser(is_b2b) ?? JSON.parse(sessionStorage.getItem('is_b2b')) ?? false;

        // Is Black Friday Promotion?
        const blackFridayPromo = getBlackFridayPromo();
        const blackFridayPromoActive = blackFridayPromo?.active ?? false;

        // Deals Promotion
        // if (!isIntStore()) {
        //     bannerTitle = 'Explorer Deals';
        //     linkLabel = __('Shop Now');
        //     linkUrl = '/deals';
        //     if (isB2B) {
        //         bannerTitle = 'Front Runner Dometic Deals';
        //         linkUrl = '/deals/b2b';
        //     }
        // }

        // Black Friday Promotion
        // if (blackFridayPromoActive) {
        //     bannerTitle = 'Black Friday Deals';
        //     linkUrl = '/deals';
        //     if (isB2B) {
        //         bannerTitle = 'Front Runner Dometic Deals';
        //         linkUrl = '/deals/b2b';
        //     }
        //     if (isEurStore()) {
        //         bannerTitle = 'Cyber Deals';
        //     }
        //     linkLabel = __('Shop Now');
        // }

        // Is Xmas Promotion?
        // const xmasPromo = getXmasPromo();
        // const xmasPromoActive = xmasPromo?.active ?? false;
        // if (xmasPromoActive) {
        //     bannerTitle = __('12 Days Of Giving - Daily Deal');
        //     linkUrl = '/deals';
        //     linkLabel = __('Shop Now');
        //     if (isB2B) {
        //         bannerTitle = '12 Days Of Giving - Deals';
        //         linkUrl = '/deals/b2b';
        //     }
        // }

        // Is Sale Promotion Active?
        // show deals link when sale period is active
        const salesPromotion = getSalesPromotion();
        const salesPromotionActive = salesPromotion?.active ?? false;

        let showForB2B = false;
        if (salesPromotionActive) {
            if (isUsaStore()) {
                if (isB2B) {
                    showForB2B = false;
                    /* bannerTitle = 'BLACK FRIDAY DISCOUNTS \'TIL NOV 27TH';
                    bannerSubtext = 'EXTRA 5% OFF ALL FRONT RUNNER DOMETIC GEAR<br />PLUS GET AN EXTRA 5% OFF ORDERS OF 20 RACKS OR MORE';
                    termsText = '*Promotion ends midnight November 27th, 2023. While supplies last.';
                    linkUrl = null;
                    linkLabel = __('Go'); */
                } else {
                    // bannerTitle = 'CHECK OUT OUR GAS BBQ / CAMP COOKER DEALS';
                    // linkUrl = '/deals';
                    // linkLabel = __('Shop Now');

                    // bannerTitle = 'Save big, play hard. 4TH of July Sale now on!';
                    // bannerSubtext = 'Buy and get free gear, save up to 40% on selected products, and more!';
                    // termsText = '*Promotion ends midnight July 9th, 2024. While supplies last.';
                    // linkUrl = '/deals';
                    // linkLabel = __('Shop Now');
                }
            }

            if (isAusStore()) {
                if (isB2B) {
                    showForB2B = true;
                    /* bannerTitle = 'EOFY SALE NOW ON';
                    bannerSubtext = 'GET AN EXTRA 5% OFF ALL FRONT RUNNER DOMETIC ORDERS NOW!';
                    termsText = '*Promotion ends midnight June 30th, 2024. While supplies last.<br />Additional discount applied at checkout.';
                    linkUrl = null;
                    linkLabel = __('Go'); */
                } else {
                    /* bannerTitle = 'EOFY SALE NOW ON - SAVE UP TO 20%';
                    linkUrl = '/deals';
                    linkLabel = __('Shop Now'); */
                }
            }

            if (isRsaStore()) {
                if (isB2B) {
                    showForB2B = false;
                    // bannerTitle = 'GET AN EXTRA 5% OFF ALL FRONT RUNNER DOMETIC ORDERS NOW!';
                    // bannerSubtext = 'GET AN EXTRA 5% OFF';
                    // termsText = '*Promotion ends midnight December 21st, 2023. While supplies last.<br />Additional discount applied at checkout.';
                    // linkUrl = null;
                    // linkLabel = __('Go');
                } else {
                    bannerTitle = 'CHECK OUT OUR HOT GAS CAMP COOKING DEALS';
                    linkUrl = '/deals';
                    linkLabel = __('Shop Now');
                }
            }

            if (isEurStore(false)) {
                if (isB2B) {
                    showForB2B = true;
                    linkUrl = '/deals/b2b';
                    linkLabel = __('Shop Now');

                    bannerTitle = 'EXPLORER DEALS​';
                    bannerSubtext = 'GET THE BEST GEAR AT EVEN BETTER PRICES!';
                    termsText = '* WHILE STOCK LASTS.';

                    // EN UK && EN DE
                    if (window.storeConfig.code === 'en_uk' || window.storeConfig.code === 'en_de') {
                        termsText = '* WHILE STOCK LASTS.';
                    }
                    // DE DE
                    if (window.storeConfig.code === 'de_de') {
                        bannerSubtext = 'DIE BESTE AUSRÜSTUNG ZU NOCH BESSEREN PREISEN!';
                        termsText = '* NUR SOLANGE DER VORRAT REICHT';
                    }
                    // FR BE
                    if (window.storeConfig.code === 'fr_be') {
                        bannerSubtext = 'OBTENEZ LE MEILLEUR ÉQUIPEMENT À DES PRIX ENCORE PLUS AVANTAGEUX !';
                        termsText = '* JUSQU\'À ÉPUISEMENT DES STOCKS';
                    }
                    // ES BE
                    if (window.storeConfig.code === 'es_be') {
                        bannerSubtext = '¡CONSIGUE EL MEJOR EQUIPO A PRECIOS AÚN MEJORES!';
                        termsText = '* HASTA AGOTAR EXISTENCIAS';
                    }
                    // NL BE
                    if (window.storeConfig.code === 'nl_be') {
                        bannerSubtext = 'KRIJG DE BESTE UITRUSTING VOOR NOG BETERE PRIJZEN!';
                        termsText = '* ZOLANG DE VOORRAAD STREKT';
                    }
                } else {
                    linkUrl = '/deals';
                    linkLabel = __('Shop Now');
                    bannerTitle = 'EXPLORER DEALS​';
                    bannerSubtext = 'GET THE BEST GEAR AT EVEN BETTER PRICES!';
                    termsText = '* WHILE STOCK LASTS.';

                    // EN UK && EN DE
                    if (window.storeConfig.code === 'en_uk' || window.storeConfig.code === 'en_de') {
                        termsText = '* WHILE STOCK LASTS.';
                    }
                    // DE DE
                    if (window.storeConfig.code === 'de_de') {
                        bannerSubtext = 'DIE BESTE AUSRÜSTUNG ZU NOCH BESSEREN PREISEN!';
                        termsText = '* NUR SOLANGE DER VORRAT REICHT';
                    }
                    // FR BE
                    if (window.storeConfig.code === 'fr_be') {
                        bannerSubtext = 'OBTENEZ LE MEILLEUR ÉQUIPEMENT À DES PRIX ENCORE PLUS AVANTAGEUX !';
                        termsText = '* JUSQU\'À ÉPUISEMENT DES STOCKS';
                    }
                    // ES BE
                    if (window.storeConfig.code === 'es_be') {
                        bannerSubtext = '¡CONSIGUE EL MEJOR EQUIPO A PRECIOS AÚN MEJORES!';
                        termsText = '* HASTA AGOTAR EXISTENCIAS';
                    }
                    // NL BE
                    if (window.storeConfig.code === 'nl_be') {
                        bannerSubtext = 'KRIJG DE BESTE UITRUSTING VOOR NOG BETERE PRIJZEN!';
                        termsText = '* ZOLANG DE VOORRAAD STREKT';
                    }
                }
            }
        } else {
            return null;
        }

        // const { customer = {} } = this.props;
        // const { is_b2b } = customer;
        // if (isB2BUser(is_b2b)) {
        //     return (
        //       <LazyLoad>
        //       <div className="fr_banner_carousel_init">
        //           { this.renderProductSlides(productSlides) }
        //       </div>
        //       </LazyLoad>
        //     );
        // }

        if (isB2B && !showForB2B) {
            return null;
        }

        // If no title is set then return null
        if (!bannerTitle) {
            return null;
        }

        // If linkUrl does not start with a "/" then add it
        if (linkUrl && !linkUrl.startsWith('/')) {
            linkUrl = `/${linkUrl}`;
        }

        return (
          <div className="fr_banner_hero">
            <h1 className="fr_banner_title">
                { bannerTitle && (
                    <span>
                        <Html content={ bannerTitle } />
                    </span>
                )}
                { linkUrl && (
                <Link
                  block="Homepage"
                  elem="Link btn btn-primary"
                  to={`${linkUrl}`}
                  onClick={ () => scrollToTop() }
                >
                    { linkLabel }
                </Link>
                ) }
            </h1>
            { bannerSubtext && (
                <div className="fr_banner_sub_title">
                    <Html content={ bannerSubtext } />
                </div>
            ) }
            { termsText && (
                <div className="fr_banner_terms_text">
                    <Html content={ termsText } />
                </div>
            ) }
          </div>
        );
    };

    renderProductSliderBlock = (blockData) => {
        const productSlides = get(blockData, 'productSlides', []);

        const { customer = {} } = this.props;
        const { is_b2b } = customer;

        // Check if B2B customer (Use local storage check)
        const isB2B = isB2BUser(is_b2b) ?? JSON.parse(sessionStorage.getItem('is_b2b')) ?? false;

        return (
            <>
            { !isB2B && (this.renderHeroBannerBlock(blockData)) }
            <LazyLoad>
              <div className="fr_banner_carousel_init">
                  { this.renderProductSlides(productSlides) }
              </div>
            </LazyLoad>
            </>
        );
    };

    renderSlimeLineBlock = (data) => {
        const {
            title_h3,
            title_h4,
            description,
            backround_image,
            link_label,
            link_url
        } = data;

        const { customer = {} } = this.props;
        const { is_b2b } = customer;
        if (isSignedIn()) {
            return null;
        }

        //  will remove when media images is render.
        // let imgUrl = backround_image;
        // if (backround_image?.includes('integration2')) {
        //     imgUrl = 'https://www.frontrunneroutfitters.com/media/revslider/Sliders_HomePage/slider_slimline_2.jpg';
        // }
        const imgUrl = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/slimline2.jpg';

        return (
        <LazyLoad>
          <div className="home_page_before_footer_section">
            <div className="container">
              <div className="content-wrapper">
                <h3>{ title_h3 }</h3>
                <h4><Html content={ title_h4 } /></h4>
                <p><Html content={ description } /></p>
                <div>
                  { !isEmpty(link_url) && (
                    <Link
                      block="Homepage"
                      elem="Link btn btn-primary"
                      to={ `/${link_url}` }
                    >
                      { link_label }
                    </Link>
                  ) }
                </div>
              </div>
            </div>
            <div className="img_sec">
              <Image
                src={ imgUrl }
                height="400"
                width="700"
                ratio="custom"
                mix={ {
                    block: 'HomePage',
                    elem: 'Image',
                    mods: { isPlaceholder: false }
                } }
                isPlaceholder={ false }
                alt="The Slimline II Roof Rack System"
              />
            </div>
          </div>
        </LazyLoad>
        );
    };

    renderLink = (label = '', link = '', key = 1, title) => (
        isEmpty(link) ? label
            : (
                <Link
                  key={ key }
                  block="HomePage"
                  elem="Link"
                  to={ removeBaseUrl(link) }
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  aria-label={ title }
                >
                          { label }
                </Link>
            )
    );

    renderFAIcon = (icon, key) => {
        const {
            title, link, icon_name, prefix
        } = icon;
        const iconPrefix = isEmpty(prefix) ? 'fab' : prefix;

        if (icon_name == 'twitter') {
            return (
              <div key={ key } className={`${ iconPrefix } ${ icon_name }`} title={ title }>
                 { this.renderLink(<FontAwesomeIcon icon={ faXTwitter } />, link, key, title) }
              </div>
            );
        }

        if (icon_name == 'linkedin') {
            return (
           <div key={ key } className={ `${ iconPrefix } ${ icon_name }` } title={ title }>
               { this.renderLink(<FontAwesomeIcon icon={ faLinkedinIn } />, link, key, title) }
           </div>
            );
        }

        return (
          <div key={ key } className={`${ iconPrefix } ${ icon_name }`} title={ title }>
            { this.renderLink(<FontAwesomeIcon icon={ [iconPrefix, icon_name] } />, link, key, title) }
          </div>
        );
    };

    renderSocialBlock = (data) => {
        const { title } = data;
        const icons = get(data, 'social_icons[0].icons');
        const subHeading = get(data, 'social_icons[0].label');
        return (
        <div className="social_block_top">
          <div><h2>{ title }</h2></div>
          <div>
            <div className="subHeading">{ subHeading }</div>
            <div className="icons">
                { ' ' }
                { map(icons, this.renderFAIcon) }
            </div>
          </div>
        </div>
        );
    };

    renderInstagramFeed = (feed, key) => {
        const { low_resolution_image: image, url } = feed;
        return (
        <div key={ key } className="col">
          <Link
            key={ key }
            block="HomePage"
            elem="Link"
            rel="noopener noreferrer"
            to={ url }
          >
            <Image
              src={ image }
              // height={"200"}
              // width={"200"}
              ratio="custom"
              mix={ {
                  block: 'HomePage',
                  elem: 'Image',
                  mods: { isPlaceholder: false }
              } }
              isPlaceholder={ false }
              alt="alt"
            />
          </Link>
        </div>
        );
    };

    handleEmailChange = (email) => {
        this.setState({ email });
    };

    handleFnameChange= (firstname) => {
        this.setState({ firstname });
    };

    handleLnameChange= (lasttname) => {
        this.setState({ lasttname });
    };

    newsLetterSignup = () => {
        const { email, firstname = '', lasttname = '' } = this.state;
        const { newsletterSubscribe, showErrorNotification } = this.props;
        if (isEmpty(email)) {
            showErrorNotification(__('Invalid Email Address'));
        } else {
            newsletterSubscribe({ email, firstname, lasttname });
        }
    };

    captchaNotification() {
        const {
            showNotification
        } = this.props;

        showNotification(
            'info',
            __('Incorrect Captcha. Please try again after sometime.')
        );
    }

    renderNewsLetterBlock = (data) => {
        const { email } = this.state;
        const { isNewsletterLoading, onSubmitSuccess = () => {}, googleRecaptchaToken = 'true' } = this.props;
        const { title } = data;
        const readNowUrl = 'en/za/gearzette';

        return (
        <div className="social_newsletter_cont">
          <Loader isLoading={ isNewsletterLoading } />
          <div><h2>{ title }</h2></div>
          <div>
            <Form
              key="email-friend"
              mix={ { block: 'EmailFriend' } }
              onSubmit={ this.newsLetterSignup }
              onSubmitSuccess={ onSubmitSuccess }
              // onSubmitError={ onError }
            >
              <Field
                type="email"
                placeholder={ __('Your Email Address') }
                id="email"
                name="email"
                // validation={ ['notEmpty', 'email'] }
                value={ email }
                onChange={ this.handleEmailChange }
              />
              <button className="btn btn-primary">
                { __('Sign up') }
              </button>
            </Form>

            { /* { <Link
              to={ readNowUrl }
              // onClick={ this.closeMenuOverlay }
              block="MenuOverlay"
              elem="Link"
              target="_blank"
            >
              { __('Read Now') }
            </Link> } */ }
          </div>
        </div>
        );
    };

    renderYotpoCarousel() {
        return (
          <div
            className="yotpo yotpo-reviews-carousel"
            data-background-color="transparent"
            data-mode="top_rated"
            data-type="site"
            data-count="9"
            data-show-bottomline="1"
            data-autoplay-enabled="1"
            data-autoplay-speed="3000"
            data-show-navigation="1"
            data-testimonials-page-enabled="1"
            data-testimonials-page-text="See All Reviews"
            data-testimonials-page-link="https://www.frontrunneroutfitters.com/en/us/reviews"
          />
        );
    }

    renderHomepageContent = (content) => {
        const { recentsPost = {} } = this.props;
        const { data = [] } = recentsPost;
        const slimlineBlock = get(content, 'slimline2_block[0]', {});
        const socialBlock = get(content, 'social_block[0]', {});
        const instagramFeeds = get(content, 'instagram_feeds', {});
        const newsletterBlock = get(content, 'newsletter_block[0]', {});
        const newLetterPopupConfig = get(this.props, 'newLetterPopupConfig', {});

        return (
        <div>
          {/* { !isEmpty(slimlineBlock) && this.renderSlimeLineBlock(slimlineBlock) } */}
          <RackFamilyBlock />
          {/* <div id="reviewsCarousel">
            { this.renderYotpoCarousel() }
          </div> */}

          <div className="container">
            { this.renderLatestGearzetteArticles(data) }
          </div>

          <div className="social_block_usa">
            <div className="container">
              { !isEmpty(socialBlock) && this.renderSocialBlock(socialBlock) }
              <div className="instafeed">
                { !isEmpty(instagramFeeds) && map(instagramFeeds, this.renderInstagramFeed) }
              </div>
              { !isEmpty(newsletterBlock) && this.renderNewsLetterBlock(newsletterBlock) }
            </div>
          </div>
        </div>
        );
    };

    renderVehicleFinder = (key, title) => {
        const accordionData = [{
            title,
            child: (<VehicleFinder />)
        }];

        return (
            <AccordionWrapper
              key={ key }
              allowMultipleExpanded
              data={ accordionData }
            />
        );
    };

    renderMobileMenu = (data, key) => {
        const {
            title, url, color, text_color, type, child, url_resolver = {}
        } = data;

        if (!isMobile.any()) {
            return null;
        }
        if (type === 'vehicle_finder') {
            return this.renderVehicleFinder(key, title);
        }

        if (isEmpty(child) && !isEmpty(url)) {
            return (
                <div key={ key } className={ type }>
                    <RouterLink
                      key={ key }
                      to={ {
                          pathname: url,
                          state: {
                              url_resolver
                          }
                      } }
                      onClick={ this.closeMenuOverlay }
                      className="MenuOverlay-Link"
                    >
                    { title }
                    </RouterLink>
                </div>
            );
        }

        if (isEmpty(child)) {
            return (
                <div key={ key } className={ type }>
                    { title }
                </div>
            );
        }

        const accordionData = [{
            url,
            title,
            child: map(child, this.renderMobileMenu),
            borderLeftColor: color,
            url_resolver
        }];

        return (
            <AccordionWrapper
              key={ key }
              allowMultipleExpanded
              data={ accordionData }
            />
        );
    };

    renderVehicleFinderSimple() {
        return (
            <div className="VehicleFinder-Home">
                <VehicleFinder />
            </div>
        );
    }

    handleCountdownComplete = () => {
        this.setState({ isCountdownComplete: true });
    };

    renderPromoCountdown = () => {
        if (isIntStore()) {
            return null;
        }

        const { customer = {} } = this.props;
        const { is_b2b } = customer;

        // Check if B2B customer (Use local storage check)
        const isB2BSession = JSON.parse(sessionStorage.getItem('is_b2b')) ?? false;

        if (isB2BUser(is_b2b) || isB2BSession) {
            return null;
        }

        const { isCountdownComplete } = this.state;
        if (isCountdownComplete) {
            return null;
        }

        // Start date is 2024-11-18
        let dateOfPromo = new Date('2025-07-25T08:00:01+02:00'); // South Africa timezone (UTC+2)
        let timeZone = 'Africa/Johannesburg';

        // If Australia, use Australia timezone for Sydney
        if (isAusStore()) {
            dateOfPromo = new Date('2025-07-25T08:00:01+10:00'); // Australia timezone (UTC+11)
            timeZone = 'Australia/Sydney';
        }

        // If Europe, use Europe timezone for Berlin
        if (isEurStore()) {
            dateOfPromo = new Date('2025-07-25T08:00:01+02:00'); // Europe timezone (UTC+2)
            timeZone = 'Europe/Berlin';
        }

        // If USA, use USA timezone for Los Angeles
        if (isUsaStore()) {
            dateOfPromo = new Date('2025-07-25T12:00:01-07:00'); // USA timezone (UTC-7)
            timeZone = 'America/Los_Angeles';
        }

        // Get current date
        const currentDate = new Date().toLocaleString('en-US', { timeZone });
        const currentDateNow = new Date(currentDate);

        // If current date is after start date, return null
        if (currentDateNow > dateOfPromo) {
            return null;
        }

        return (
            <section id="PromoCountdown-Section" className="dark">
              <div className="container">
                <h2>
                  { __('Big deal incoming') }
                </h2>
                <SalesLargeCountdown endDate={ dateOfPromo } onComplete={ this.handleCountdownComplete } />
              </div>
            </section>
        );
    };

    renderTopSlider = () => {
        const { customer = {}, companyCustomerData = {} } = this.props;
        const { is_b2b } = customer;

        // Check if B2B customer (Use local storage check)
        const isB2BSession = JSON.parse(sessionStorage.getItem('is_b2b')) ?? false;

        const salesPromotion = getSalesPromotion();
        const salesPromotionActive = salesPromotion?.active ?? false;
        const showDealsLink = salesPromotion?.showDealsLink ?? false;

        let bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-hero-desktop-d2c.jpg';
        let bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-hero-mobile-d2c.jpg';

        if (isAusStore() || isRsaStore() || isIntStore()) {
            bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-hero-desktop-d2c.jpg';
            bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-hero-mobile-d2c.jpg';
        }

        if (isEurStore()) {
            bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/eu-summer-slider-2025-hero-slider-1-desktop-b2c.jpg';
            bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/eu-summer-slider-2025-hero-slider-1-mobile-b2c.jpg';

            if (isB2BUser(is_b2b) || isB2BSession) {
                bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/eu-summer-slider-2025-hero-slider-1-desktop-b2c.jpg';
                bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/eu-summer-slider-2025-hero-slider-1-mobile-b2b.jpg';
            }
        }

        // Change banner image for promo
        // TODO: @Chris disable promo banner for B2B users after Black Friday
        /* if (salesPromotionActive) {
            let staticPromoTextHeader = '';
            let staticPromoTextSubheader = '';

            if (isB2BUser(is_b2b)) {
                if (isUsaStore()) {
                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/juqbuxgcu9bzfmgs6tko.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/zdtt0yfazw1xhl0vxfhv-mobile.jpg';
                    staticPromoTextHeader = 'Extra 10% off all orders over $1000';
                    staticPromoTextSubheader = 'Black Friday discounts \'til Dec 2nd';
                }

                if (isAusStore()) {
                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/w9d61plewro2ujsjhr4l.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/xceooo7riup1sjmwb2yk-mobile.jpg';
                    staticPromoTextHeader = 'EXTRA 5% OFF ALL GEAR<br />PLUS GET AN EXTRA 5% OFF ORDERS OF 5 RACKS OR MORE';
                    staticPromoTextSubheader = 'Black Friday discounts \'til Dec 2nd';
                }

                if (isRsaStore()) {
                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/4fbwxpnr8lqqavudcgih.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/68cbhkh84iucoc7hn00w-mobile.jpg';
                    staticPromoTextHeader = 'EXTRA 5% OFF ALL GEAR<br />PLUS GET AN EXTRA 5% OFF ORDERS OF 5 RACKS OR MORE';
                    staticPromoTextSubheader = 'Black Friday discounts \'til Dec 2nd';
                }

                if (isEurStore()) {
                    if (window.storeConfig.code === 'en_de') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/kukqueawksbqyjwaxq3s.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/potkzds3p693parkxjpz-mobile.jpg';
                        staticPromoTextHeader = 'EXTRA 5% OFF ALL GEAR<br />PLUS GET AN EXTRA 5% OFF ORDERS OF 5 RACKS OR MORE';
                        staticPromoTextSubheader = 'Black Friday discounts \'til Dec 2nd';
                    }
                    if (window.storeConfig.code === 'de_de') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/fliozwwxj9quqqctvmtc.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/ubght7xc5ssqlcbn9yap-mobile.jpg';
                        staticPromoTextHeader = 'EXTRA 5% RABATT AUF ALLE PRODUKTE<br />PLUS: ERHALTEN SIE WEITERE 5% RABATT BEI BESTELLUNGEN VON 5 DACHTRÄGERN ODER MEHR';
                        staticPromoTextSubheader = 'BLACK FRIDAY DEALS BIS ZUM 2. DEZEMBER';
                    }
                    if (window.storeConfig.code === 'fr_be') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/ba69vmw1m2bhawcsqzox.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/mzbizxt8aivl3pkoswnf-mobile.jpg';
                        staticPromoTextHeader = '5% SUR TOUT L\'ÉQUIPEMENT<br />EN PLUS, BÉNÉFICIEZ DE 5% SUPPLÉMENTAIRES SUR LES COMMANDES DE 5 GALERIES OU PLUS';
                        staticPromoTextSubheader = 'RÉDUCTIONS BLACK FRIDAY JUSQU\'AU 2 DÉCEMBRE';
                    }
                    if (window.storeConfig.code === 'es_be') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/rlbbrqp9ytnpi2pkkhmo.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/hbped7noaiiqsimuljb2-mobile.jpg';
                        staticPromoTextHeader = '5% EXTRA EN TODO EL EQUIPO<br />ADEMÁS, OBTENGA UN 5% DE DESCUENTO ADICIONAL EN PEDIDOS DE 5 BACAS DE TECHO O MÁS';
                        staticPromoTextSubheader = 'BLACK FRIDAY DESCUENTOS HASTA EL 2 DE DICIEMBRE';
                    }
                    if (window.storeConfig.code === 'nl_be') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/aje3pxttllz3bjxujqy2.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/9epb8cn36gywuswyhpwn-mobile.jpg';
                        staticPromoTextHeader = 'EXTRA 5% OP ALLE PRODUCTEN<br />BOVENDIEN KRIJGT U EXTRA 5% KORTING BIJ BESTELLINGEN VAN 5 DAKDRAGERS OF MEER';
                        staticPromoTextSubheader = 'BLACK FRIDAY KORTINGEN TOT 2 DECEMBER';
                    }
                    if (window.storeConfig.code === 'en_uk') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/kukqueawksbqyjwaxq3s.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/potkzds3p693parkxjpz-mobile.jpg';
                        staticPromoTextHeader = 'EXTRA 5% OFF ALL GEAR<br />PLUS GET AN EXTRA 5% OFF ORDERS OF 5 RACKS OR MORE';
                        staticPromoTextSubheader = 'Black Friday discounts \'til Dec 2nd';
                    }
                }

                return (
                    <>
                    <div className="topStaticBannerPromo">
                        <picture>
                        <source media="(max-width: 800px)" srcSet={ bannerTopImgMobile } />
                        <source media="(min-width: 801px)" srcSet={ bannerTopImg } />
                        <img src={ bannerTopImg } alt="Outfit Your Vehicle | Front Runner Dometic" width="1920" height="745" />
                        </picture>
                    </div>

                    <div className="topStaticPromoText">
                        <div className="container">
                            <div className="topStaticPromoTextHeader">
                                <Html content={ staticPromoTextHeader } />
                            </div>
                            <div className="topStaticPromoTextSubheader">
                                <Html content={ staticPromoTextSubheader } />
                            </div>
                        </div>
                    </div>
                    </>
                );
            } else {
                if (isUsaStore()) {
                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/black-friday-2024-up-to-50-off.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/black-friday-2024-up-to-50-off-mobile.jpg';
                    staticPromoTextHeader = 'BLACK FRIDAY SALE ​NOW ON';
                    staticPromoTextSubheader = 'UP TO 50% OFF SELECTED ITEMS';

                    if (window.storeConfig.code === 'es_us') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/es/black-friday-2024-up-to-50-off.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/es/black-friday-2024-up-to-50-off-mobile.jpg';
                        staticPromoTextHeader = 'OFERTAS DE BLACK FRIDAY​ A PARTIR DE AHORA​';
                        staticPromoTextSubheader = 'DESCUENTOS HASTA EL 50% EN ARTÍCULOS SELECCIONADOS';
                    }
                }

                if (isAusStore()) {
                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/fkk7wplt9aid2x9yhzma.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/zavwwannynqftevlwq93-mobile.jpg';
                    staticPromoTextHeader = 'BLACK FRIDAY SALE ​NOW ON';
                    staticPromoTextSubheader = 'UP TO 40% OFF SELECTED ITEMS';
                }

                if (isRsaStore()) {
                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/fkk7wplt9aid2x9yhzma.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/zavwwannynqftevlwq93-mobile.jpg';
                    staticPromoTextHeader = 'BLACK FRIDAY SALE ​NOW ON';
                    staticPromoTextSubheader = 'UP TO 40% OFF SELECTED ITEMS';
                }

                if (isEurStore()) {
                    if (window.storeConfig.code === 'en_de') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/w4b3xxlatglys0d20hq0.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/zlpfklohfzzbvi4pslaf-mobile.jpg';
                        staticPromoTextHeader = 'BLACK FRIDAY SALE ​NOW ON';
                        staticPromoTextSubheader = 'UP TO 50% OFF SELECTED ITEMS';
                    }
                    if (window.storeConfig.code === 'de_de') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/aasi4pdhsisxk6rd7ici.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/fzxc3recm0lgimswxvz8-mobile.jpg';
                        staticPromoTextHeader = 'BLACK FRIDAY DEALS JETZT ERHÄLTLICH';
                        staticPromoTextSubheader = 'BIS ZU 50% AUF AUSGEWÄHLTE PRODUKTE';
                    }
                    if (window.storeConfig.code === 'fr_be') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/ywcrrfjmqyp9ok6ststg.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/kdrkcfnyze97puh7ulkc-mobile.jpg';
                        staticPromoTextHeader = 'BLACK FRIDAY DEALS EN COURS';
                        staticPromoTextSubheader = 'JUSQU\'À 50% SUR CERTAINS ARTICLES';
                    }
                    if (window.storeConfig.code === 'es_be') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/hpajj9fmmqmrypyilviz.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/72blt9l1tpqghf5ml77r-mobile.jpg';
                        staticPromoTextHeader = 'BLACK FRIDAY DEALS YA DISPONIBLES';
                        staticPromoTextSubheader = 'HASTA UN 50% EN ARTÍCULOS SELECCIONADOS';
                    }
                    if (window.storeConfig.code === 'nl_be') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/ru9jwwbxjcvfwzpj5pmf.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/2tlqbkhmnwpxtttoof5a-mobile.jpg';
                        staticPromoTextHeader = 'BLACK FRIDAY DEALS NU BESCHIKBAAR';
                        staticPromoTextSubheader = 'TOT 50% OP GESELECTEERDE ITEMS';
                    }
                    if (window.storeConfig.code === 'en_uk') {
                        bannerTopImg = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/w4b3xxlatglys0d20hq0.jpg';
                        bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/frontrunner/sliders/desktop/zlpfklohfzzbvi4pslaf-mobile.jpg';
                        staticPromoTextHeader = 'BLACK FRIDAY SALE ​NOW ON';
                        staticPromoTextSubheader = 'UP TO 50% OFF SELECTED ITEMS';
                    }
                }

                return (
                    <>
                    <div className="topStaticBannerPromo">
                      <picture>
                        <source media="(max-width: 800px)" srcSet={ bannerTopImgMobile } />
                        <source media="(min-width: 801px)" srcSet={ bannerTopImg } />
                        <img src={ bannerTopImg } alt="Front Runner Dometic Black Friday Sale Now On - Up to 50% off" width="1920" height="745" />
                      </picture>
                    </div>

                    <div className="topStaticPromoText">
                        <div className="container">
                            <div className="topStaticPromoTextHeader">
                                <Html content={ staticPromoTextHeader } />
                            </div>
                            <div className="topStaticPromoTextSubheader">
                                <Html content={ staticPromoTextSubheader } />
                            </div>
                            <div className="topStaticPromoTextButton">
                              <Link
                                className="btn btn-primary"
                                to="/deals"
                              >
                                { __('Shop Now') }
                              </Link>
                            </div>
                        </div>
                    </div>
                    </>
                );
            }
        } */

        if (salesPromotionActive) {
            const storeCode = window.storeConfig.code;

            let bannerTopText = '';
            let bannerSubText = '';
            let bannerLink = showDealsLink ? '/deals' : null;

            // bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/aus/xmas-24-home-hero-desktop1-d2c.jpg';
            // bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/aus/xmas-24-home-hero-mobile-d2c.jpg';

            // if (isAusStore()) {
            //     bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagedesktop-d2c.jpg';
            //     bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagemobile-d2c.jpg';
            // }

            // if (isRsaStore()) {
            //     bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagedesktop-d2c.jpg';
            //     bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagemobile-d2c.jpg';
            // }

            // if (isUsaStore()) {
            //     bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/us-4-july-sale-b2b-desktop.jpg';
            //     bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/us-4-july-sale-b2b-mobile.jpg';
            // }

            // if (isEurStore()) {
            //     bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/deals/eu/eu-explorer-deals-may-2025.jpg';
            //     bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/deals/eu/eu-explorer-deals-may-2025-mobile.jpg';

            //     if (isB2BUser(is_b2b)) {
            //         bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagedesktop-d2c.jpg';
            //         bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagemobile-d2c.jpg';
            //     }
            // }

            if (isB2BUser(is_b2b) || isB2BSession) {
                bannerLink = showDealsLink ? '/deals/b2b' : null;

                if (isEurStore()) {
                    bannerTopText = 'Explorer Deals';
                    bannerSubText = '';

                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/eur/2025-aug/header-explorer-deals-image-1-desktop-b2b.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/eur/2025-aug/header-explorer-deals-image-1-mobile-b2b.jpg';
                }

                // if (isUsaStore()) {
                // bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/labor-day-hero-slider-2-desktopus-winter.jpg';
                // bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/labor-day-hero-slider-2-mobileus-winter.jpg';

                // bannerTopText = 'Celebrating 25 Years';
                // bannerSubText = 'Additional 10% Off all Front Runner Gear.<br />Until Midnight on July 25th.<br />Discount applied at checkout.';
                // bannerLink = null;
                // }
            } else {
                // if (storeCode === 'en_za') {
                //     bannerTopText = '10% OFF ALL RACKS <br>AND GET FREE GEAR';
                //     bannerSubText = 'UNTIL MIDNIGHT ON 13th APRIL 2025';
                // }
                // if (storeCode === 'en_au') {
                //     bannerTopText = '10% OFF ALL RACKS <br>AND GET FREE GEAR';
                //     bannerSubText = 'UNTIL MIDNIGHT ON 13th APRIL 2025';
                // }

                bannerLink = null;

                if (isUsaStore()) {
                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/us-4-july-sale-b2b-desktop.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/usa/us-4-july-sale-b2b-mobile.jpg';

                    bannerTopText = 'LABOR DAY SALE UP TO 70% OFF';
                    bannerSubText = 'August 22nd - September 1st';
                    bannerLink = '/deals';
                }

                // if (isAusStore()) {
                //     bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagedesktop-d2c.jpg';
                //     bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagemobile-d2c.jpg';

                //     bannerTopText = '25% OFF FRONT RUNNER GEAR<br />25 HOURS ONLY';
                //     bannerSubText = 'Starting 8am 25 July until 9am 26 July.<br /><a href="/deals/terms">Terms and Conditions apply.</a>';
                // }

                // if (isRsaStore()) {
                //     bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagedesktop-d2c.jpg';
                //     bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/fr-au-za-25years-homepagemobile-d2c.jpg';

                //     bannerTopText = '25% OFF FRONT RUNNER GEAR<br />25 HOURS ONLY';
                //     bannerSubText = 'Starting 8am 25 July until 9am 26 July.<br /><a href="/deals/terms">Terms and Conditions apply.</a>';
                // }

                if (isEurStore()) {
                    bannerTopText = 'Explorer Deals';
                    bannerSubText = '';
                    bannerLink = '/deals';

                    bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/eur/2025-aug/header-explorer-deals-image-1-desktop-b2c.jpg';
                    bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/eur/2025-aug/header-explorer-deals-image-1-mobile-b2c.jpg';
                }

                // if (['en_de', 'en_uk', 'nl_be'].includes(storeCode)) {
                //     bannerSubText = 'Only until 9 am 26 July 2025.<br /><a href="/deals/terms">Terms and Conditions apply.</a>';
                // }
                // if (storeCode === 'de_de') {
                //     bannerSubText = 'Nur bis 9:00 Uhr am 26. Juli 2025.<br /><a href="/deals/terms">Es gelten die Allgemeinen Geschäftsbedingungen.</a>';
                // }
                // if (storeCode === 'fr_be') {
                //     bannerSubText = 'Uniquement jusqu\'à 9h le 26 juillet 2025.<br /><a href="/deals/terms">Conditions applicables.</a>';
                // }
                // if (storeCode === 'es_be') {
                //     bannerSubText = 'Solo hasta las 9:00 del 26 de julio de 2025.<br /><a href="/deals/terms">Se aplican términos y condiciones.</a>';
                // }
            }

            // if (isUsaStore() && !isB2BUser(is_b2b)) {
            //     return (
            //       <Link
            //         to="/deals"
            //         onClick={ () => scrollToTop() }
            //       >
            //         <div className="topStaticBannerPromo">
            //           <picture>
            //             <source media="(max-width: 800px)" srcSet={ bannerTopImgMobile } />
            //             <source media="(min-width: 801px)" srcSet={ bannerTopImg } />
            //             <img src={ bannerTopImg } alt={`${bannerTopText}`} width="1920" height="745" />
            //           </picture>
            //         </div>
            //       </Link>
            //     );
            // }

            return (
              <div className="topStaticBanner topStaticBannerPromo">
                  <picture>
                    <source media="(max-width: 800px)" srcSet={ bannerTopImgMobile } />
                    <source media="(min-width: 801px)" srcSet={ bannerTopImg } />
                    <img src={ bannerTopImg } alt={`${bannerTopText}`} width="1920" height="745" />
                  </picture>
                  { bannerTopText && (
                    <div className="topStaticBannerWrap topStaticBannerWrapPromo">
                        <h1>
                          <Html content={ bannerTopText } />
                        </h1>

                        <div className="topStaticBannerWrapPromoSubText">
                          <Html content={ bannerSubText } />
                        </div>

                        { bannerLink && (
                          <div block="topStaticBannerWrap" elem="Actions">
                            <Link
                              className="btn btn-primary"
                              to={ bannerLink }
                              onClick={ () => scrollToTop() }
                            >
                            { __('Shop Now') }
                            </Link>
                          </div>
                        )}
                    </div>
                  )}
              </div>
            );
        }

        // KEEP SEARCHING CAMPAIGN
        if ((!isB2BUser(is_b2b) && !isB2BSession)) {
            bannerTopImgMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/keep-searching-mobile.jpg';
            bannerTopImg = 'https://www.frontrunneroutfitters.com/media/landing-pages/promotions/keep-searching-desktop.jpg';

            let locationList = [
                {
                    name: 'KOSI BAY, SOUTH AFRICA'
                },
                {
                    name: 'SANI PASS, LESOTHO'
                },
                {
                    name: 'NORTHERN CAPE, SOUTH AFRICA'
                }
            ];

            if (window.storeConfig.code === 'de_de') {
                locationList = [
                    {
                        name: 'KOSI BAY, SÜDAFRIKA'
                    },
                    {
                        name: 'SANI PASS, LESOTHO'
                    },
                    {
                        name: 'NÖRDLICHES KAP, SÜDAFRIKA'
                    }
                ];
            }

            if (window.storeConfig.code === 'fr_be') {
                locationList = [
                    {
                        name: 'KOSI BAY, AFRIQUE DU SUD'
                    },
                    {
                        name: 'SANI PASS, LESOTHO'
                    },
                    {
                        name: 'CAP-NORD, AFRIQUE DU SUD'
                    }
                ];
            }

            if (window.storeConfig.code === 'es_be') {
                locationList = [
                    {
                        name: 'KOSI BAY, SUDÁFRICA'
                    },
                    {
                        name: 'SANI PASS, LESOTO'
                    },
                    {
                        name: 'CABO NORTE, SUDÁFRICA'
                    }
                ];
            }

            if (window.storeConfig.code === 'nl_be') {
                locationList = [
                    {
                        name: 'KOSI BAY, SOUTH AFRICA'
                    },
                    {
                        name: 'SANI PASS, LESOTHO'
                    },
                    {
                        name: 'NORTHERN CAPE, SOUTH AFRICA'
                    }
                ];
            }

            return (
                <>
              <div className="KS_topStaticBanner">
                  <picture>
                    <source media="(max-width: 800px)" srcSet={ bannerTopImgMobile } />
                    <source media="(min-width: 801px)" srcSet={ bannerTopImg } />
                    <img src={ bannerTopImg } alt="Outfit Your Vehicle | Front Runner Dometic" width="1920" height="745" />
                  </picture>
                  <div className="topStaticBannerWrap">
                      <img className="floatingImage" src="https://www.frontrunneroutfitters.com/media/landing-pages/promotions/keep-searching-text.png" alt="Keep Searching" />

                      <ul className="locationList">
                        { locationList.map((location, index) => (
                          <li key={ location.name }>{ location.name }</li>
                        )) }
                      </ul>

                      <div block="topStaticBannerWrap" elem="Actions">
                        <button
                          className="btn btn-primary"
                          onClick={ () => {
                              this.showVideosPopup();
                          } }
                        >
                          <FontAwesomeIcon icon={ faPlayCircle } style={{ marginRight: '10px' }} />
                          { __('Watch video') }
                        </button>

                        <button
                          className="btn btn-primary-outline"
                          onClick={ () => {
                              this.showFindGearPopup();
                          } }
                        >
                          { __('Find gear by vehicle') }
                        </button>
                      </div>
                  </div>
              </div>

              <div className="review_rating_section">
                  <div className="review_rating">
                      <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                      <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                      <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                      <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                      <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                      <span>
                      { __('Trusted by 250,000+ adventurers worldwide') }
                      </span>
                  </div>
              </div>
                </>
            );
        }

        return (
            <div className="topStaticBanner">
                <picture>
                <source media="(max-width: 800px)" srcSet={ bannerTopImgMobile } />
                <source media="(min-width: 801px)" srcSet={ bannerTopImg } />
                <img src={ bannerTopImg } alt="Outfit Your Vehicle | Front Runner Dometic" width="1920" height="745" />
                </picture>
                <div className="topStaticBannerWrap">
                    <div className="review_rating">
                        <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                        <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                        <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                        <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                        <FontAwesomeIcon icon={ faStar } size="1x" color="#F0C332" />
                        <span>
                        { __('Trusted by 250,000+ adventurers worldwide') }
                        </span>
                    </div>

                    <h1>
                    { __('The toughest gear for off-road adventures') }
                    </h1>

                    <div block="topStaticBannerWrap" elem="Actions">
                      <button
                        className="btn btn-primary"
                        onClick={ () => {
                            this.showFindGearPopup();
                        } }
                      >
                      { __('Find gear by vehicle') }
                      </button>

                      <Link
                        className="btn btn-primary-outline"
                        to="/vehicles"
                        onClick={ () => scrollToTop() }
                      >
                      { __('Popular vehicles') }
                      </Link>
                    </div>
                </div>
            </div>
        );
    };

    showFindGearPopup = () => {
        const { isEnabledFindGearPopup = false } = this.state;
        this.setState({ isEnabledFindGearPopup: !isEnabledFindGearPopup });
    };

    renderFindGearPopup = () => {
        const { isEnabledFindGearPopup = false } = this.state;

        if (!isEnabledFindGearPopup) {
            return null;
        }

        return (
          <div className="findGearPopup">
              <div className="findGearPopupWrapp">
                  <div onClick={ this.showFindGearPopup } className="close"><CloseIcon /></div>
                  <div className="findGearPopupContent">
                      <div className="h3">
                        { __('Outfit your vehicle') }
                      </div>
                      <h2>
                        { __('Find gear specific to your vehicle') }
                      </h2>
                      <div className="h4">
                        { __("Select your vehicle's year, make and model to find compatible gear.") }
                      </div>
                      <div>
                        <VehicleFinder isHomeTop />
                      </div>
                  </div>
              </div>
          </div>
        );
    };

    renderSecStaticSlider= () => {
        // Block Headers
        let secStatic1Header = __('Racks');
        let secStatic2Header = __('Rack Accessories');
        let secStatic3Header = __('Load Bars');
        // Block Titles
        let secStatic1Title = __('Strong, Lightweight & Modular');
        let secStatic2Title = __('Secure your gear easily & reliably');
        let secStatic3Title = __('Customize your rack for your adventure');
        // Block Images
        let secStatic1Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-racks.jpg';
        let secStatic2Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-rack-accessories.jpg';
        let secStatic3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-load-bars.jpg';
        // Block Links
        let secStatic1Link = '/roof-racks.html';
        let secStatic2Link = '/rack-accessories.html';
        let secStatic3Link = '/load-bars.html';

        if (isRsaStore() || isIntStore() || isAusStore()) {
            secStatic1Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-racks.jpg';
            secStatic2Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-rack-accessories.jpg';
            secStatic3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-load-bars.jpg';
            secStatic3Header = 'Load Bars';
        }

        if (isEurStore()) {
            secStatic1Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-racks.jpg';
            secStatic2Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-rack-accessories.jpg';
            secStatic3Header = __('Tents');
            secStatic3Title = __('Durable, compact, and adventure-ready');
            secStatic3Link = '/camping-gear/tents-awnings.html';
            secStatic3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-tents.jpg';
        }

        if (isUsaStore()) {
            secStatic3Header = 'Cross Bars';
        }

        if (isRsaStore()) {
            secStatic3Header = 'Cross Bars';
            // secStatic3Link = '/cross-bars.html';
            secStatic3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/int-sub-cross-bars.jpg';
        }

        // Block Img Alt
        let secStatic1Alt = `${secStatic1Header} - ${secStatic1Title} | Front Runner Dometic`;
        let secStatic2Alt = `${secStatic2Header} - ${secStatic2Title} | Front Runner Dometic`;
        let secStatic3Alt = `${secStatic3Header} - ${secStatic3Title} | Front Runner Dometic`;

        return (
          <div className="staticBannerSecond">
            <h2>
              { __('Shop popular adventure gear') }
            </h2>
            <div className="staticBannerWrap">
                <Link
                  block="PopularAdv"
                  elem="Link"
                  to={ secStatic1Link }
                  onClick={ () => scrollToTop() }
                >
                  <div className="staticBannerItem">
                      <img src={ `${secStatic1Img}?width=640&height=430&fit=cover` } alt={ secStatic1Alt } width="640" height="430" />
                      <h3>
                        { secStatic1Header }
                      </h3>
                      <div className="staticBannerItemContent">
                        <div className="subTitle">
                          { secStatic1Title }
                        </div>
                        <Link
                          block="Homepage"
                          elem="Link btn btn-primary"
                          to={ secStatic1Link }
                          onClick={ () => scrollToTop() }
                        >
                          { __('Shop Now') }
                        </Link>
                      </div>
                  </div>
                </Link>
                <Link
                  block="PopularAdv"
                  elem="Link"
                  to={ secStatic2Link }
                  onClick={ () => scrollToTop() }
                >
                  <div className="staticBannerItem">
                      <img src={ `${secStatic2Img}?width=640&height=430&fit=cover` } alt={ secStatic2Alt } loading="lazy" width="640" height="430" />
                      <h3>
                        { secStatic2Header }
                      </h3>
                      <div className="staticBannerItemContent">
                        <div className="subTitle">
                          { secStatic2Title }
                        </div>
                        <Link
                          block="Homepage"
                          elem="Link btn btn-primary"
                          to={ secStatic2Link }
                          onClick={ () => scrollToTop() }
                        >
                          { __('Shop Now') }
                        </Link>
                      </div>
                  </div>
                </Link>
                <Link
                  block="PopularAdv"
                  elem="Link"
                  to={ secStatic3Link }
                  onClick={ () => scrollToTop() }
                >
                  <div className="staticBannerItem">
                      <img src={ `${secStatic3Img}?width=640&height=430&fit=cover` } alt={ secStatic3Alt } loading="lazy" width="640" height="430" />
                    <h3>
                      { secStatic3Header }
                    </h3>
                    <div className="staticBannerItemContent">
                      <div className="subTitle">
                        { secStatic3Title }
                      </div>
                      <Link
                        block="Homepage"
                        elem="Link btn btn-primary"
                        to={ secStatic3Link }
                        onClick={ () => scrollToTop() }
                      >
                        { __('Shop Now') }
                      </Link>
                    </div>
                  </div>
                </Link>
            </div>
          </div>
        );
    };

    renderStaticCategories = () => {
        // Block Headers
        let block1Header = __('Camping Essentials');
        let block2Header = __('Storage Solutions');
        let block3Header = __('Water Solutions');
        let block4Header = __('Power & Lighting');
        let block5Header = __('Coolers & Fridges');
        let block6Header = __('Ladders');
        // Block Images
        let block1Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/int-category-camp.jpg';
        let block2Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/int-category-storage.jpg';
        let block3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/int-category-water.jpg';
        let block4Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/int-category-power.jpg';
        let block5Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/int-category-coolers-fridges.jpg';
        let block6Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/us-category-ladders.jpg';
        // Block Links
        let block1Link = '/camping-gear.html';
        let block2Link = '/storage-systems.html';
        let block3Link = '/water-solutions.html';
        let block4Link = '/battery-solutions.html';
        let block5Link = '/refrigeration.html';
        let block6Link = '/ladders.html';

        if (isUsaStore()) {
            block1Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-camp.jpg';
            block2Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-storage.jpg';
            block3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-water.jpg';
            block4Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-power.jpg';
            block5Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-coolers.jpg';
            block6Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-ladders.jpg';
        }

        if (isAusStore() || isRsaStore() || isIntStore()) {
            block1Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-camp.jpg';
            block2Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-storage.jpg';
            block3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-water.jpg';
            block4Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-power.jpg';
            block5Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-coolers.jpg';
            block6Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-ladders.jpg';
        }

        if (isEurStore()) {
            block1Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-camp.jpg';
            block2Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-storage.jpg';
            block3Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-water.jpg';
            block4Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-power.jpg';
            block5Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-coolers.jpg';
            block6Img = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-int-homepage-template-ladders.jpg';
        }

        // Block Img Alt
        let block1Alt = 'Camping Essentials | Front Runner Dometic';
        let block2Alt = 'Storage Solutions | Front Runner Dometic';
        let block3Alt = 'Water Solutions | Front Runner Dometic';
        let block4Alt = 'Power & Lighting | Front Runner Dometic';
        let block5Alt = 'Coolers & Fridges | Front Runner Dometic';
        let block6Alt = 'Ladders | Front Runner Dometic';

        return (
          <div className="staticCategoriesSec container">
            <h2>
              { __('Explore more gear for your adventure') }
            </h2>
            <div className="staticCategoriesWrap">
                <div className="staticCategories">
                  <Link
                    to={ block1Link }
                    className="staLink"
                    onClick={ () => scrollToTop() }
                  >
                    <img src={ `${block1Img}?width=440&height=440&fit=cover` } alt={ block1Alt } loading="lazy" width="440" height="440" />
                    <h3>
                      { block1Header }
                    </h3>
                  </Link>
                </div>
                <div className="staticCategories">
                  <Link
                    to={ block2Link }
                    className="staLink"
                    onClick={ () => scrollToTop() }
                  >
                    <img src={ `${block2Img}?width=440&height=440&fit=cover` } alt={ block2Alt } loading="lazy" width="440" height="440" />
                    <h3>
                      { block2Header }
                    </h3>
                  </Link>
                </div>
                <div className="staticCategories">
                  <Link
                    to={ block3Link }
                    className="staLink"
                    onClick={ () => scrollToTop() }
                  >
                    <img src={ `${block3Img}?width=440&height=440&fit=cover` } alt={ block3Alt } loading="lazy" width="440" height="440" />
                    <h3>
                      { block3Header }
                    </h3>
                  </Link>
                </div>
                <div className="staticCategories">
                  <Link
                    to={ block4Link }
                    className="staLink"
                    onClick={ () => scrollToTop() }
                  >
                    <img src={ `${block4Img}?width=440&height=440&fit=cover` } alt={ block4Alt } loading="lazy" width="440" height="440" />
                    <h3>
                      { block4Header }
                    </h3>
                  </Link>
                </div>
                <div className="staticCategories">
                  <Link
                    to={ block5Link }
                    className="staLink"
                    onClick={ () => scrollToTop() }
                  >
                    <img src={ `${block5Img}?width=440&height=440&fit=cover` } alt={ block5Alt } loading="lazy" width="440" height="440" />
                    <h3>
                      { block5Header }
                    </h3>
                  </Link>
                </div>
                <div className="staticCategories">
                  <Link
                    to={ block6Link }
                    className="staLink"
                    onClick={ () => scrollToTop() }
                  >
                    <img src={ `${block6Img}?width=440&height=440&fit=cover` } alt={ block6Alt } loading="lazy" width="440" height="440" />
                    <h3>
                      { block6Header }
                    </h3>
                  </Link>
                </div>
            </div>
          </div>

        );
    };

    renderVehicleTestFitmentsBlocks = () => {
        // Only show on EUR store
        if (!isEurStore()) {
            return null;
        }

        // Only show for Germany and English Germany
        if (window.storeConfig.code !== 'de_de' && window.storeConfig.code !== 'en_de') {
            return null;
        }

        const desktopImage = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/2025-eu-test-fitment.jpg';
        const mobileImage = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/2025-eu-test-fitment-mobile.jpg';
        const header = __('Get a free rack');
        const body = [
            __('Help us develop new roof racks and receive one for free for your vehicle')
        ];
        const linkText = __('Learn more');
        const linkUrl = '/vehicle-test-fitments';

        return (
            <CmsBanner
              header={header}
              body={body}
              linkText={linkText}
              linkUrl={linkUrl}
              desktopImage={desktopImage}
              mobileImage={mobileImage}
              imageAlt={__('Test fit a new rack on your vehicle')}
            />
        );
    };

    renderYotpoLoyaltyBanner = () => {
        // TODO: Active once Yotpo Loyalty is available for EUR
        let image = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/explorer-rewards-desktop.jpg';
        let imageMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/explorer-rewards-mobile-v2.jpg';

        if (isUsaStore()) {
            image = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-explorer-rewards-dektop.jpg';
            imageMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/us-homepage-spring-2025-explorer-rewards-mobile.jpg';
        }

        if (isAusStore() || isRsaStore() || isIntStore()) {
            image = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-explorer-rewards-dektop.jpg';
            imageMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/aus-za-homepage-winter-explorer-rewards-mobile.jpg';
        }

        if (isEurStore()) {
            image = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/2025-fr-int-homepage-rewards-banner-explorer-rewards-dektop.jpg';
            imageMobile = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/2025-fr-int-homepage-rewards-banner-explorer-rewards-mobile.jpg';
        }

        return (
          <div className="container">
            <div className="yotpo-loyalty-banner">
              <picture>
                  <source media="(min-width: 768px)" srcSet={ image } />
                  <source media="(max-width: 767px)" srcSet={ imageMobile } />
                  <img src={ image } alt="Front Runner Dometic Explorer Rewards" loading="lazy" />
              </picture>
              <div className="yotpo-loyalty-banner-content">
                  <div className="yotpo-loyalty-banner-text">
                      <h2>Explorer Rewards</h2>
                      <p>
                        { __('Join now to earn points and exclusive rewards every time you shop!') }
                      </p>
                  </div>
                  <Link
                    to="/rewards"
                    className="yotpo-loyalty-banner-button btn btn-primary"
                    onClick={() => scrollToTop()}
                  >
                      { __('Learn more') }
                  </Link>
              </div>
            </div>
          </div>
        );
    };

    renderCmsBanner = () => {
        if (window.storeConfig.code !== 'de_de') {
            return null;
        }

        const desktopImage = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-explores-desktop.jpg';
        const mobileImage = 'https://www.frontrunneroutfitters.com/media/landing-pages/home/2025/fr-explores-mobile.jpg';
        const header = 'Front Runner Dometic Explores';
        const body = [
            'Die ultimative Community-Overlanding-Reise 28. September - 3. Oktober 2025',
            'Erkunde spektakuläre Offroad-Strecken und erlebe echtes Abenteuer!'
        ];
        const linkText = 'JETZT PLATZ SICHERN';
        const linkUrl = '/pages/front-runner-dometic-explores';

        return (
            <CmsBanner
              header={header}
              body={body}
              linkText={linkText}
              linkUrl={linkUrl}
              desktopImage={desktopImage}
              mobileImage={mobileImage}
              imageAlt="Front Runner Dometic Explorer Rewards"
            />
        );
    };

    renderStaticBrandVideo = () => (
      <Suspense fallback={
          <Loader isLoading />
      }
      >
      <LazyBrandVideo />
      </Suspense>
    );

    render() {
        const {
            page, isBreadcrumbsActive, mobileHeaderTextBanner, updateMeta
        } = this.props;
        // const { page_width = 2 } = page;
        const page_width = 200;
        const sliderBlock = get(this.props, 'slider.slides', []);
        const productSliderBlock = get(this.props, 'productSlider', null);
        const content = get(this.props, 'content', {});
        const newLetterPopupConfig = get(this.props, 'newLetterPopupConfig', {});
        let mobileAccordian = get(this.props, 'mobileAccordian', {});

        const salesPromotion = getSalesPromotion();
        const salesPromotionActive = salesPromotion?.active ?? false;

        // Add Deals to mobile menu
        if (salesPromotionActive) {
            const deals = {
                title: __('Deals'),
                url: '/deals',
                type: 'deals',
                color: '#fff',
                text_color: '#000',
                child: []
            };

            mobileAccordian = [...mobileAccordian, deals];
        }

        return (
            <main
              block="HomePage"
              mods={ { isBreadcrumbsHidden: !isBreadcrumbsActive } }
            >
                <div block="HomePage" elem="Wrapper" mods={ { page_width } }>
                    { /* <Meta metaObject={ metaObject } /> */ }
                    { /* { this.renderHeading() } */ }
                    <div block="HomePage" elem="Content">
                        { /* Moved this section in Header */ }
                        { false && !isEmpty(mobileHeaderTextBanner)
                          && (
                              <div className="m-value-proposition">
                              &nbsp;
                              { ' ' }
                              { mobileHeaderTextBanner }
                              </div>
                          ) }
                        {/* <div className="mobile-slide-down-nav">
                            { !isEmpty(mobileAccordian) && map(mobileAccordian, this.renderMobileMenu) }
                        </div> */}
                        <div className="fr_slider_top">
                            {/* { (!isUsaStore() && !isRsaStore() && !isAusStore() && !isIntStore()) && !isEmpty(sliderBlock) && this.renderOwlSlider(sliderBlock) } */}
                            { this.renderTopSlider() }
                        </div>
                        { this.renderB2cContent() }
                        { this.renderB2bContent() }
                        { this.renderVideosPopup() }
                        { this.renderFindGearPopup() }
                        {/* { !isEmpty(content) && this.renderHomepageContent(content) } */}
                        <VideoPopup />
                    </div>
                    {/* <WithGoogleRecaptcha updateGoogleRecaptcha={ this.props.updateGoogleRecaptcha } /> */}
                </div>

            </main>
        );
    }
}

// eslint-disable-next-line no-undef
export default HomePageComponent;
